import script from "./CordenadorEquipe.vue?vue&type=script&setup=true&lang=js"
export * from "./CordenadorEquipe.vue?vue&type=script&setup=true&lang=js"

import "./CordenadorEquipe.vue?vue&type=style&index=0&id=67f73794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f73794"]])

export default __exports__